"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = require("./constants");
/**
 * Check if element visually fits on the screen
 */
var isFullyVisible = function (bounds, container) {
    var containerEl = container || document.documentElement;
    var pageLeft = containerEl.scrollLeft;
    var pageRight = pageLeft + containerEl.clientWidth;
    var pageTop = containerEl.scrollTop;
    var pageBottom = pageTop + containerEl.clientHeight;
    return (bounds.left >= pageLeft + constants_1.SCREEN_OFFSET &&
        bounds.left + bounds.width <= pageRight - constants_1.SCREEN_OFFSET &&
        bounds.top >= pageTop &&
        bounds.top + bounds.height <= pageBottom);
};
exports.default = isFullyVisible;
